// Dependencies
import NewsSlider from 'slider';


class News {
  /**
   * Constructor: News Constructor.
   */
  constructor(options = {}) {
    // Context
    this._context = options.context || document;

    // Root
    this._root = this._context.querySelector('[type="news"]');
    
    // Elements
    this._cards = [...this._root.querySelectorAll('.news-card')];
    this._prev  = this._root.querySelector('.news__prev');
    this._next  = this._root.querySelector('.news__next');

    // Slider Class
    this.Slider = new NewsSlider({
      root   : this._root,
      nodes  : this._cards,
      buttons: {
        prev: this._prev,
        next: this._next,
      },
    });
  }
}

export default News;


// WEBPACK FOOTER //
// ./src/js/layouts/news/index.js